import React from 'react';
import Swal from 'sweetalert2';
import { DELETE } from '../../ApiServices/ApiServices';

const DeleteButton = ({ url, onDeleteSuccess }) => {
    const handleDelete = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    // Call the DELETE API
                    const response = await DELETE(url);
                    console.log(response, "delete response");

                    // Show success pop-up with auto-close
                    Swal.fire({
                        title: 'Deleted!',
                        text: response.message,
                        icon: 'success',
                        confirmButtonColor: '#3085d6',
                        timer: 2000, // Auto-close after 2 seconds
                        timerProgressBar: true, // Show progress bar
                        showConfirmButton: false, // Hide OK button (optional)
                        allowOutsideClick: false, // Prevent closing by clicking outside
                        allowEscapeKey: false, // Prevent closing with Escape key
                    });

                    // Trigger the onDeleteSuccess callback if provided
                    if (onDeleteSuccess) {
                        onDeleteSuccess();
                    }
                } catch (error) {
                    console.error('Error deleting item:', error);

                    // Show error pop-up
                    Swal.fire({
                        title: 'Error!',
                        text: error.message,
                        icon: 'error',
                        confirmButtonColor: '#3085d6',
                    });
                }
            }
        });
    };

    return (
        <a onClick={handleDelete} className="trashDeleteIcon" style={{ cursor: "pointer" }}>
            <em className="icon ni ni-trash"></em>
        </a>
    );
};

export default DeleteButton;